import styled from 'styled-components';

export const Banner = styled.div`
  padding-bottom: 40px;
  border-bottom: 1px solid ${(p) => p.theme.colors.neutral.container};
  margin-bottom: 40px;
`;
